import { useEffect } from 'react';

import { useAuthInfo, useRedirectFunctions } from '@propelauth/react';

import { useGlobalStore } from '../stores/useGlobalStore';

const AuthContext = ({ children }) => {
  const { loading, isLoggedIn, accessToken } = useAuthInfo();
  const setAccessToken = useGlobalStore((s) => s.setAccessToken);
  const { redirectToLoginPage } = useRedirectFunctions();

  useEffect(() => {
    setAccessToken(accessToken || '');
  }, [accessToken, setAccessToken]);

  if (loading) {
    return null;
  }

  // TODO - Figure out a better way for this
  if (
    !isLoggedIn &&
    window.location.pathname !== '/signup' &&
    window.location.pathname !== '/register' &&
    window.location.pathname !== '/account-signup' &&
    window.location.pathname !== '/account-request' &&
    window.location.pathname !== '/terms'
  ) {
    redirectToLoginPage({
      userSignupQueryParameters: { opt_hint: 'pw,sso' },
      postLoginRedirectUrl: window.location.href,
    });
    return null;
  }

  return <>{children}</>;
};

export default AuthContext;
